import { useCallback, useEffect, useRef, useState } from 'react'
import useCopyToClipboard from 'react-use/lib/useCopyToClipboard'

export function useClipboard(timeout = 2000) {
  const [, copyToClipboard] = useCopyToClipboard()
  const [copied, setCopied] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const copy = useCallback(
    (text: string) => {
      copyToClipboard(text)
      setCopied(true)

      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      timerRef.current = setTimeout(() => {
        setCopied(false)
      }, timeout)
    },
    [copyToClipboard, timeout],
  )

  const reset = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    setCopied(false)
  }, [])

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [])

  return {
    copied,
    copy,
    reset,
  }
}
